import React from 'react'

import type { ParkinglotConfirmInfoProps } from '@/components/purchase/components/shared/purchaseConfirmInfo/view'

import BottomSheet from '@/shared/components/BottomSheet'
import { Caption, Text } from '@/shared/components/typography/index'

const ParkinglotConfirmInfo = ({ isOpen, carNumValue, onClick, onClose, data }: ParkinglotConfirmInfoProps) => {
  const bottomContent = (
    <div className="flex flex-col w-full">
      <div className="px-4 py-5 my-6 rounded-lg bg-main-010">
        <Text level="text1" weight="bold" color="main050" className="mb-4 text-left">
          {carNumValue}
        </Text>
        <div className="flex flex-col gap-1">
          <div className="flex justify-between">
            <Caption level="caption2" color="text070">
              주차권
            </Caption>
            <Caption level="caption2" color="text090">
              {data.couponName}
            </Caption>
          </div>
          <div className="flex justify-between">
            <Caption level="caption2" color="text070">
              상품 가격
            </Caption>
            <Caption level="caption2" color="text090">
              {data.price.toLocaleString()}원
            </Caption>
          </div>
        </div>
      </div>
      <div className="mb-10">
        <Text level="text3" color="text090" weight="bold" className="mb-[6px] text-left">
          주차권 <span className="text-caution-070">사용이 불가</span>한 상황
        </Text>
        <ol className="list-disc">
          <li className="list-style-desc">
            <Caption level="caption2" color="text070">
              입차 후 주차권 구매
            </Caption>
          </li>
          <li className="list-style-desc">
            <Caption level="caption2" color="text070">
              출차 없이 주차권 2개 이상 연속 사용
            </Caption>
          </li>
          <li className="list-style-desc">
            <Caption level="caption2" color="text070">
              주차권 유효시간 외 주차
            </Caption>
          </li>
          <li className="list-style-desc">
            <Caption level="caption2" color="text070">
              한번 출차 후 재입차
            </Caption>
          </li>
        </ol>
      </div>
    </div>
  )
  return (
    <BottomSheet
      isOpen={isOpen}
      title="결제 전 반드시 확인해 주세요."
      ptValue="pt-8"
      bodyContent={bottomContent}
      btnText="위 내용을 확인했습니다"
      className="body-1 h-[56px]"
      pyValue="py-0"
      onClick={onClick}
      onClose={onClose}
    />
  )
}

export default ParkinglotConfirmInfo
